import { render, staticRenderFns } from "./TTab.vue?vue&type=template&id=bc304f08&scoped=true&"
import script from "./TTab.vue?vue&type=script&lang=js&"
export * from "./TTab.vue?vue&type=script&lang=js&"
import style0 from "./TTab.vue?vue&type=style&index=0&id=bc304f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc304f08",
  null
  
)

/* custom blocks */
import block0 from "./TTab.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports